import StatusesGolfForm1 from "./StatusesGolfForm1";
import StatusesGolfForm2 from "./StatusesGolfForm2";

const StatusesGolf = ({ success, data }) => {
	return (
		<>
			<StatusesGolfForm1 success={success} data={data} />
			<StatusesGolfForm2 success={success} data={data} />
		</>
	);
};

export default StatusesGolf;
